import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import s from './EmptyWatchedGroups.scss';
var EmptyWatchedGroups = function (props) {
    var t = useTranslation().t;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    if (isLoggedIn) {
        return (React.createElement("div", { className: s['groups-empty'] },
            React.createElement("div", { className: s['watch-groups'] }, t('networkBar.groups.empty.header')),
            React.createElement("div", { className: s['but-why'] }, t('networkBar.groups.empty.text'))));
    }
    return (React.createElement("div", { className: classnames(s['groups-empty'], s['anon']) },
        React.createElement("div", { className: s['but-why'] }, t('networkBar.groups.empty.anon.text')),
        React.createElement(BrandedButton, { variant: "brand-green", size: "small", className: s['signup'], href: Url.joinLink(), biData: {
                evid: BiEventType.REDIRECT_TO_LOGIN,
                referral_info: ReferralType.ANON_NETWORKBAR,
            } }, t('networkBar.groups.empty.anon.join'))));
};
EmptyWatchedGroups.displayName = 'EmptyWatchedGroups';
export default EmptyWatchedGroups;
//# sourceMappingURL=EmptyWatchedGroups.js.map